module.exports = __webpack_public_path__ + "static/img/certificate_my.ef7c7395.png";